/** Keep in sync with packages/backend/src/services/supermarketStoreTypes.ts */
const SUPERMARKET_STORE_TYPES = new Set([
  'edeka',
  'rewe',
  'kaufland',
  'lidl',
  'aldi',
  'netto_marken',
  'netto',
  'penny',
  'norma',
  'bio_company',
  'alnatura',
  'denns',
]);

export function isSupermarketStoreType(storeType: string | null | undefined): boolean {
  return SUPERMARKET_STORE_TYPES.has(String(storeType ?? '').trim().toLowerCase());
}

export interface CasePriceInput {
  storeType?: string | null;
  priceNet: number;
  unitsPerCase?: number | null;
  lehUnitPriceNet?: number | null;
  override?: number | null;
}

/** Net case price. A typed override wins. Supermarkets use the LEH unit price × pack size. */
export function resolveCasePrice(input: CasePriceInput): number {
  if (input.override !== null && input.override !== undefined) return input.override;
  const units = Number(input.unitsPerCase);
  const leh = input.lehUnitPriceNet;
  if (
    isSupermarketStoreType(input.storeType) &&
    leh !== null &&
    leh !== undefined &&
    Number.isFinite(leh) &&
    units > 0
  ) {
    return (Math.round(leh * 100) * units) / 100;
  }
  return input.priceNet;
}

export function lehUnitPrice(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function catalogCasePrice(
  variant: {
    price_net: number | string;
    units_per_case: number | string;
    leh_unit_price_net?: number | string | null;
  },
  storeType: string | null | undefined,
  override?: number | null
): number {
  return resolveCasePrice({
    storeType,
    priceNet: Number(variant.price_net),
    unitsPerCase: Number(variant.units_per_case),
    lehUnitPriceNet: lehUnitPrice(variant.leh_unit_price_net),
    override,
  });
}
